<template>
  <section class="hello">
    <header>
      <h1>{{ msg }}</h1>
      <p class="tagline">Senior Data Engineer &middot; Freelance &middot; Remote</p>
    </header>

    <main>
      <p class="description">
        10+ years building cloud-native data platforms across retail, ad-tech, gaming, and finance.
        Deep expertise in GCP and AWS — scalable pipelines, dimensional models, and BI at scale.
        Currently available for freelance engagements in Europe and the US.
      </p>

      <a
        class="linkedin-follow"
        href="https://www.linkedin.com/in/constantin-lungu-668b8756/"
        target="_blank"
        rel="noopener"
        aria-label="Follow Constantin Lungu on LinkedIn"
      >
        <svg class="linkedin-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
        Follow on LinkedIn
      </a>
    </main>

    <footer>
      <h2 class="connect-heading">Connect</h2>
      <nav aria-label="Social and professional links">
        <ul class="link-list">
          <li>
            <a href="https://github.com/cnstlungu" target="_blank" rel="noopener">
              GitHub
            </a>
          </li>
          <li>
            <a href="https://medium.com/@cnstlungu" target="_blank" rel="noopener">
              Medium
            </a>
          </li>
          <li>
            <a href="https://www.notjustsql.com" target="_blank" rel="noopener">
              Newsletter
            </a>
          </li>
          <li>
            <a href="https://datawise.dev" target="_blank" rel="noopener">
              Blog
            </a>
          </li>
        </ul>
      </nav>
      <img
        class="cert-badge"
        src="../assets/aws-dataanalytics-certification.png"
        alt="AWS Certified Data Analytics – Specialty"
        width="56"
        height="56"
        loading="lazy"
      >
    </footer>
  </section>
</template>

<script>
export default {
  name: 'HomePage',
  props: {
    msg: String
  }
}
</script>

<style scoped>
h1 {
  font-size: 2rem;
  margin: 0 0 6px;
  color: #2c3e50;
}

.tagline {
  font-size: 1rem;
  color: #6b7c93;
  margin: 0 0 24px;
  letter-spacing: 0.02em;
}

.description {
  max-width: 580px;
  margin: 0 auto 28px;
  line-height: 1.7;
  font-size: 1rem;
}

/* LinkedIn follow button */
.linkedin-follow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #0A66C2;
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 10px 20px;
  border-radius: 24px;
  margin-bottom: 32px;
  transition: background 0.15s;
}

.linkedin-follow:hover,
.linkedin-follow:focus {
  background: #004182;
  text-decoration: none;
  outline: none;
}

.linkedin-icon {
  width: 18px;
  height: 18px;
  fill: #fff;
  flex-shrink: 0;
}

/* Cert badge */
.cert-badge {
  width: 56px;
  height: 56px;
  object-fit: contain;
  margin-top: 20px;
  opacity: 0.85;
}

/* Footer / Connect */
.connect-heading {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6b7c93;
  margin: 0 0 14px;
}

.link-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

.link-list li a {
  display: inline-block;
  padding: 8px 18px;
  border: 1.5px solid #d0daf0;
  border-radius: 6px;
  color: #2d6ef7;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: background 0.15s, border-color 0.15s;
}

.link-list li a:hover,
.link-list li a:focus {
  background: #f0f4ff;
  border-color: #2d6ef7;
  outline: none;
}

a {
  color: #2d6ef7;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

/* Mobile */
@media (max-width: 480px) {
  h1 {
    font-size: 1.6rem;
  }

  .skills {
    text-align: left;
  }

  .skill-label {
    min-width: 64px;
  }

  .link-list li a {
    padding: 10px 14px;
    font-size: 0.95rem;
  }
}
</style>
